"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WIX_CODE_CHATROOM_TYPE = void 0;
exports.WIX_CODE_CHATROOM_TYPE = {
    SOCIAL: 'Social',
    BUSINESS: 'Business',
    PRIVATE: 'Private',
    GROUP: 'Group',
    FOCUSED: 'Focused'
};
//# sourceMappingURL=constants-wixCode.js.map